export default __webpack_public_path__ + "static/media/paper-plane.d003a722.svg";